import { Report } from '@/app/models/costTracking';
import { FinancialGroup } from '@/app/models/financalGroup';
import { useSearchCostTrackingQuery } from '@/app/services/costTrackingApi';
import LateralDrawer from '@/components/common/LateralDrawer';
import PageTitle from '@/components/common/pageTitle';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import FinalBalanceTable from './FinalBalanceTable';
import NewEditFinalBalance from './NewEditFinalBalance';

interface FinalBalanceProps {
  group: FinancialGroup | undefined;
}

function FinalBalance(props: FinalBalanceProps) {
  const { code } = useParams();
  const { t } = useTranslation(['costTracking', 'common']);

  const { group } = props;

  const [drawerEdit, setDrawerEdit] = useState(false);

  const { data: costTracking } = useSearchCostTrackingQuery(
    {
      project: code || '',
      rubric: group?.code as string,
    },
    {
      skip: !code || !group,
    },
  );

  const [selectedItem, setSelectedItem] = useState<Report[]>();

  return (
    <Box>
      <PageTitle title={t('monthly.information')} sx={{ b: 0 }} />
      <FinalBalanceTable setDrawerEdit={setDrawerEdit} setSelectedItem={setSelectedItem} data={costTracking} />
      <LateralDrawer open={drawerEdit} setOpen={setDrawerEdit} position="right" size="bigger">
        <NewEditFinalBalance selectItem={selectedItem as Report[]} setDrawerOpen={setDrawerEdit} />
      </LateralDrawer>
    </Box>
  );
}

export default FinalBalance;
